module.exports = "/images/gestionPedido.svg";